export const formatPhoneNumber = (
  countryCode: string,
  phoneNumber: string
): string => {
  return `${countryCode} ${phoneNumber}`;
};
